<template>
  <div ref="tooltip" class="tooltip left">
    <div class="text w-full">
      <slot></slot>
    </div>
    <span v-if="!disabled" class="tooltiptext">{{ text }}</span>
  </div>
</template>
<script>
export default {
  name: "Tooltip",
  props: {
    text: {
      type: String,
      required: false,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
<style lang="scss">
.tooltip .tooltiptext {
  visibility: hidden;
  // width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  margin-left: 40px;
  /* Position the tooltip */
  position: absolute;
  z-index: 10;
  max-width: 140px;
}
.tooltip .text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
.tooltip.down:hover .tooltiptext {
  margin-top: 10px;
  margin-left: -60px;
}
.tooltip.left:hover .tooltiptext {
  margin-left: -130px;
  margin-top: -5px;
}
</style>
